import React from "react";
import "../styles/HowToCoverLetter.css";

function HowToCoverLetter() {
  return (
    <div className="how-to-write-cover-letter">
      <h1>How to Write a Cover Letter</h1>
      <ol>
        <li>
          <strong>Start with a professional header:</strong> Include your
          contact information and the date.
        </li>
        <li>
          <strong>Address the hiring manager by name:</strong> Make the letter
          personal if possible.
        </li>
        <li>
          <strong>Open with a strong introduction:</strong> Mention the position
          and where you found the listing.
        </li>
        <li>
          <strong>Highlight relevant experience:</strong> Discuss your skills
          that are directly related to the role.
        </li>
        <li>
          <strong>Showcase your achievements:</strong> Provide examples of past
          achievements in similar positions.
        </li>
        <li>
          <strong>Explain why you’re interested in this company:</strong> Show
          knowledge about the company and its goals.
        </li>
        <li>
          <strong>Convey enthusiasm for the role:</strong> Let them know you’re
          excited about the opportunity.
        </li>
        <li>
          <strong>Close with a call to action:</strong> Mention that you’d like
          to discuss further in an interview.
        </li>
        <li>
          <strong>Use a professional closing:</strong> Sign off with "Sincerely"
          or "Best regards".
        </li>
        <li>
          <strong>Proofread:</strong> Double-check for spelling and grammar
          errors.
        </li>
      </ol>
    </div>
  );
}

export default HowToCoverLetter;
